import Vue from 'vue';
import VueI18n from 'vue-i18n';

import internationalizationEn from '@/internationalization/en';
import internationalizationFr from '@/internationalization/fr';

Vue.use(VueI18n);

// eslint-disable-next-line
let vueI18n;

if (vueI18n == null) {
  vueI18n = new VueI18n({
    locale: window.processEnv.VUE_APP_DEFAULT_LANGUAGE,
    messages: {
      'en-US': {
        ...internationalizationEn,
      },
      'fr-CA': {
        ...internationalizationFr,
      },
    },
  });
}

export default vueI18n;
